import { Stack, Avatar, Typography, useTheme, Tooltip } from '@mui/material';
import React from 'react';
import {
  ComposableMap,
  ZoomableGroup,
  Geographies,
  Geography,
  Marker,
} from 'react-simple-maps';
import { resizeImage } from '../../api/cloudinary';

type PropTypes = {
  customCenter?: [number, number];
  userLocations: any[];
};

export const PlayersAroundTheWorld = ({
  customCenter,
  userLocations,
}: PropTypes) => {
  const theme = useTheme();

  const userTooltip = (user: any) => {
    return (
      <Stack direction="row" spacing={1}>
        <Avatar
          src={resizeImage(user.avatarPublicId, 80, 80)}
          variant="rounded"
          sx={{
            height: 80,
            width: 80,
          }}
        />
        <Stack spacing={1}>
          <Typography
            variant="h6"
            textAlign="center"
            sx={{
              color:
                theme.palette.mode === 'light'
                  ? theme.palette.secondary.main
                  : theme.palette.text.primary,
              textShadow:
                theme.palette.mode === 'dark'
                  ? `0 0 1px ${theme.palette.secondary.main}, 10px 0px 20px ${theme.palette.secondary.main}, 0px 0px 16px ${theme.palette.secondary.main}`
                  : 'none',
            }}
          >
            {user.username}
          </Typography>
          <Typography
            variant="subtitle1"
            textAlign="center"
            sx={{
              color:
                theme.palette.mode === 'light'
                  ? theme.palette.dailies.main
                  : theme.palette.text.primary,
              textShadow:
                theme.palette.mode === 'dark'
                  ? `0 0 1px ${theme.palette.dailies.main}, 10px 0px 20px ${theme.palette.dailies.main}, 0px 0px 16px ${theme.palette.dailies.main}`
                  : 'none',
            }}
          >
            {user.location}
          </Typography>
        </Stack>
      </Stack>
    );
  };

  return (
    <ComposableMap projection="geoMercator" width={800} height={400}>
      <ZoomableGroup center={customCenter || [0, 0]} zoom={1}>
        <Geographies geography={'./worldMap.json'}>
          {({ geographies }) =>
            geographies.map((geo) => (
              <Geography key={geo.rsmKey} geography={geo} />
            ))
          }
        </Geographies>
        {userLocations
          ?.filter((u) => !!u.locationLongitude)
          .map((u) => (
            <Tooltip title={userTooltip(u)} placement="top">
              <Marker coordinates={[u.locationLongitude, u.locationLatitude]}>
                <circle r={1} fill="#48d2ff" />
              </Marker>
            </Tooltip>
          ))}
      </ZoomableGroup>
    </ComposableMap>
  );
};
